<template>
  <div class="main-content">
    <div class="header d-none">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Person on Board</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">All Current Users Location</p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-12"></div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="card">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">User Activity</h4>
              <b-button
                variant="primary"
                @click.prevent="refreshData"
                style="margin-left: 7px"
              >
                <span v-if="!loading" class="fe fe-refresh-cw"></span>
                <span v-else>
                  <b-spinner small label="Small Spinner"></b-spinner>
                </span>
              </b-button>
              <b-button
                v-b-toggle.collapse-1
                variant="primary"
                style="margin-left: 7px"
              >
                <span class="fe fe-sliders"></span>
              </b-button>
            </div>
            <b-collapse id="collapse-1">
              <form @submit="getAllPointing">
                <div
                  class="row mt-4"
                  style="margin-left: 15px; margin-right: 15px"
                >
                  <div class="col-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1" class="form-label">
                        Location
                      </label>
                      <v-select
                        v-model="filter.location_id"
                        :options="locations"
                        label="location_name"
                        @input="changeLocation"
                        :reduce="(e) => e.id"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <label for="exampleInputEmail1" class="form-label">
                      Users
                    </label>
                    <v-select
                      v-model="filter.user_id"
                      :options="listUser"
                      label="fullname"
                      :reduce="(e) => e.id"
                    >
                      <template slot="option" slot-scope="option">
                        <div class="d-flex">
                          <div
                            class="mr-2 d-flex"
                            v-if="
                              option.is_wfh === false &&
                              option.is_active === true
                            "
                          >
                            <div class="circle bg-primary"></div>
                            <div class="status-info ml-2">WFO Active</div>
                          </div>
                          <div
                            class="mr-2 d-flex"
                            v-if="
                              option.is_wfh === false &&
                              option.is_active === false
                            "
                          >
                            <div class="circle bg-warning"></div>
                            <div class="status-info ml-2">WFO Away</div>
                          </div>
                          <div
                            class="mr-2 d-flex"
                            v-if="
                              option.is_wfh === true &&
                              option.is_active === true
                            "
                          >
                            <div class="circle bg-dark"></div>
                            <div class="status-info ml-2">WFH Active</div>
                          </div>
                          <div
                            class="mr-2 d-flex"
                            v-if="
                              option.is_wfh === true &&
                              option.is_active === false
                            "
                          >
                            <div class="circle bg-light"></div>
                            <div class="status-info ml-2">WFH Away</div>
                          </div>
                          <div>{{ option.fullname }}</div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="row mb-3" style="margin-right: 15px">
                  <div class="col"></div>
                  <div class="col-auto">
                    <!-- Button -->
                    <button
                      type="button"
                      class="btn btn-outline-secondary lift mr-2"
                      @click.prevent="clearFilter"
                    >
                      Clear Filter
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary lift"
                      @click.prevent="refreshData"
                    >
                      Filter
                    </button>
                  </div>
                </div>
              </form>
            </b-collapse>
            <div class="card-body">
              <!-- Maps -->
              <div>
                <b-tabs v-model="tabIndex">
                  <b-tab>
                    <template #title>
                      <i class="fe fe-map"></i>
                      <span class="ml-2">Map</span>
                    </template>
                    <div class="mt-4">
                      <!-- <div class="float-start d-flex">Zoom: {{ zoom }}</div> -->
                      <div class="d-flex mb-3 float-end">
                        <div class="mr-2 d-flex">
                          <div class="circle bg-primary"></div>
                          <div class="status-info ml-2">WFO Active</div>
                        </div>
                        <div class="mr-2 d-flex">
                          <div class="circle bg-warning"></div>
                          <div class="status-info ml-2">WFO Away</div>
                        </div>
                        <div class="mr-2 d-flex">
                          <div class="circle bg-dark"></div>
                          <div class="status-info ml-2">WFH Active</div>
                        </div>
                        <div class="mr-2 d-flex">
                          <div class="circle bg-light"></div>
                          <div class="status-info ml-2">WFH Away</div>
                        </div>
                      </div>
                      <vl-map
                        ref="map"
                        :load-tiles-while-animating="true"
                        :load-tiles-while-interacting="true"
                        :style="`height: 70vh; margin-bottom: 1.5rem`"
                        @click="clickPosition"
                        data-projection="EPSG:4326"
                      >
                        <vl-view
                          ref="view"
                          :zoom.sync="zoom"
                          :center.sync="center"
                          :rotation.sync="rotation"
                        ></vl-view>

                        <template v-for="emp in listPointing">
                          <vl-feature
                            :id="`emp-${emp.id}`"
                            :key="emp.id"
                            :properties="emp"
                            v-if="emp.last_position_coordinate && zoom >= 9"
                          >
                            <vl-geom-point
                              :coordinates="[
                                emp.last_position_coordinate.y,
                                emp.last_position_coordinate.x,
                              ]"
                            ></vl-geom-point>
                            <vl-style>
                              <vl-style-icon
                                :src="getIcon(emp)"
                                :scale="0.025"
                              />
                            </vl-style>
                          </vl-feature>
                        </template>

                        <vl-layer-tile id="osm">
                          <vl-source-osm></vl-source-osm>
                        </vl-layer-tile>

                        <vl-layer-vector>
                          <vl-source-vector>
                            <template v-for="(item, i) in modifiedLoc">
                              <vl-feature
                                :id="`area-${i}`"
                                :properties="item"
                                :key="`area-${item.id}`"
                                v-if="item.type == 'polygon'"
                              >
                                <vl-geom-polygon
                                  :coordinates="
                                    Array.isArray(item.raw_geolocation[0][0])
                                      ? item.raw_geolocation
                                      : [item.raw_geolocation]
                                  "
                                ></vl-geom-polygon>
                                <vl-style>
                                  <vl-style-stroke
                                    :color="item.stroke"
                                  ></vl-style-stroke>
                                  <vl-style-fill
                                    :color="item.fill"
                                  ></vl-style-fill>
                                  <vl-style-text
                                    :text="item.location_name"
                                    font="14px Montserrat"
                                  ></vl-style-text>
                                </vl-style>
                              </vl-feature>
                              <vl-feature
                                :id="`rad-${i}`"
                                :properties="item"
                                :key="`area-rad-${item.id}`"
                                v-else
                              >
                                <vl-geom-circle :coordinates="item.raw_geolocation" :radius="adjustedRadius(item.radius)"></vl-geom-circle>
                                <vl-style>
                                  <vl-style-stroke
                                    :color="item.stroke"
                                  ></vl-style-stroke>
                                  <vl-style-fill
                                    :color="item.fill"
                                  ></vl-style-fill>
                                  <vl-style-text
                                    :text="item.location_name"
                                    font="14px Montserrat"
                                  ></vl-style-text>
                                </vl-style>
                              </vl-feature>
                            </template>
                          </vl-source-vector>
                        </vl-layer-vector>

                        <vl-interaction-select
                          :features.sync="selectedFeatures"
                        >
                          <template slot-scope="selection">
                            <vl-style
                              v-if="
                                selectedFeatures[0]?.geometry.type == 'Polygon'
                              "
                            >
                              <vl-style-stroke
                                color="blue"
                                :width="3"
                              ></vl-style-stroke>
                              <vl-style-fill
                                :color="selectedFeatures[0]?.properties.fill"
                              ></vl-style-fill>
                              <vl-style-text
                                :text="
                                  selectedFeatures[0]?.properties.location_name
                                "
                                font="14px Montserrat"
                              ></vl-style-text>
                            </vl-style>
                            <vl-style
                              v-else-if="
                                selectedFeatures[0]?.geometry.type == 'Point'
                              "
                            >
                              <template
                                v-if="
                                  selectedFeatures[0]?.properties
                                    .feature_type == 'person'
                                "
                              >
                                <vl-style-icon
                                  :src="`/img/marker.png`"
                                  :scale="0.035"
                                />
                              </template>
                              <template v-else>
                                <vl-style-icon
                                  :src="`/img/marker.png`"
                                  :scale="0.05"
                                />
                              </template>
                            </vl-style>
                            <!-- overlay -->
                            <vl-overlay
                              v-for="feature in selection.features"
                              :key="feature.id"
                              :id="feature.id"
                              :position="
                                feature.geometry.type == 'Polygon'
                                  ? feature.geometry.coordinates[0][0]
                                  : feature.geometry.coordinates
                              "
                              :auto-pan="true"
                              :auto-pan-animation="{ duration: 300 }"
                            >
                              <template slot-scope="scope">
                                <div
                                  class="toast"
                                  role="alert"
                                  aria-live="assertive"
                                  aria-atomic="true"
                                  style="
                                    display: block;
                                    opacity: 1;
                                    visibility: visible;
                                  "
                                >
                                  <template
                                    v-if="feature.geometry.type == 'Polygon'"
                                  >
                                    <div class="toast-header">
                                      <strong class="me-auto">{{
                                        feature.properties.location_name
                                      }}</strong>
                                      <!-- <b-link v-b-modal.detail-area><small>Detail</small></b-link> -->
                                      <!-- <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button> -->
                                    </div>
                                    <div class="toast-body">
                                      <table class="table table-sm mb-0">
                                        <tr>
                                          <th>Total Active</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ feature.properties.total_active }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Total Away</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ feature.properties.total_away }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Total WFH</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ feature.properties.total_wfh }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Total WFH Active</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ feature.properties.total_wfh_active }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Total WFH Away</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ feature.properties.total_wfh_away }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Total WFO</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ feature.properties.total_wfo }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Total WFO Active</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ feature.properties.total_wfo_active }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Total WFO Away</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ feature.properties.total_wfo_away }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Coordinates</th>
                                          <td class="px-2">:</td>
                                          <td>
                                            {{ scope.position[1] }},
                                            {{ scope.position[0] }}
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </template>
                                  <template
                                    v-else-if="feature.geometry.type == 'Point'"
                                  >
                                    <div class="toast-body">
                                      <template
                                        v-if="
                                          feature.properties.feature_type ==
                                          'person'
                                        "
                                      >
                                        <table class="table table-sm mb-0">
                                          <tr>
                                            <th>NIK</th>
                                            <td class="px-2">:</td>
                                            <td>
                                              {{ feature.properties.nik }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <th>Name</th>
                                            <td class="px-2">:</td>
                                            <td>
                                              {{ feature.properties.fullname }}
                                            </td>
                                          </tr>
                                          <tr>
                                            <th>Company</th>
                                            <td class="px-2">:</td>
                                            <td>
                                              {{
                                                feature.properties.company_name
                                              }}
                                            </td>
                                          </tr>
                                        </table>
                                        <div class="d-flex justify-content-end">
                                          <b-link href="#" @click="viewUser()"
                                            >Detail</b-link
                                          >
                                        </div>
                                      </template>
                                      <template v-else>
                                        <small>Muster Point</small>
                                        <h3 class="mb-0">
                                          {{
                                            feature.properties.muster_point_name
                                          }}
                                        </h3>
                                      </template>
                                    </div>
                                  </template>
                                </div>
                              </template>
                            </vl-overlay>
                          </template>
                        </vl-interaction-select>
                      </vl-map>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template #title>
                      <i class="fe fe-list"></i>
                      <span class="ml-2">List</span>
                    </template>
                    <div class="mt-4">
                      <vue-good-table
                        :columns="columns"
                        :rows="listPointing"
                        :pagination-options="{
                          enabled: true,
                          perPage: 5,
                          perPageDropdown: [5, 10, 50, 100],
                        }"
                      >
                        <template slot="table-row" slot-scope="props">
                          <div v-if="props.column.field === 'coordinate'">
                            <template v-if="props.row.last_position_coordinate">
                              <div>
                                {{ props.row.last_position_coordinate.x }},
                                {{ props.row.last_position_coordinate.y }}
                              </div>
                            </template>
                          </div>
                          <div v-else-if="props.column.field === 'action'">
                            <div>
                              <button
                                class="btn btn-primary"
                                @click.prevent="trackUser(props.row)"
                              >
                                <i class="fe fe-map-pin"></i>
                              </button>
                            </div>
                          </div>
                        </template>
                      </vue-good-table>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
              <!-- End of Maps -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Employee -->
    <b-modal
      id="view-profile"
      size="xl"
      title="Employee Profile"
      hide-footer
      @hide="onUnselect"
      centered
    >
      <div class="row">
        <div class="col-6 mb-3">
          <div class="d-flex w-100">
            <div class="d-flex flex-column">
              <img
                :src="user.image"
                alt="image profile"
                width="100px"
                height="100px"
                @error="user.image = '/img/profile.webp'"
                class="rounded-circle border border-dark"
              />
            </div>
            <div class="mt-auto mb-auto ml-4">
              <h3 class="mb-2">
                {{ user.fullname || "Unknown User" }}
              </h3>
              <div class="d-flex">
                <div class="d-flex mb-3">
                  <div
                    class="mr-2 d-flex"
                    v-if="user.is_wfh === false && user.is_active === true"
                  >
                    <div class="circle bg-primary"></div>
                    <div class="status-info ml-2">WFO Active</div>
                  </div>
                  <div
                    class="mr-2 d-flex"
                    v-if="user.is_wfh === false && user.is_active === false"
                  >
                    <div class="circle bg-warning"></div>
                    <div class="status-info ml-2">WFO Away</div>
                  </div>
                  <div
                    class="mr-2 d-flex"
                    v-if="user.is_wfh === true && user.is_active === true"
                  >
                    <div class="circle bg-dark"></div>
                    <div class="status-info ml-2">WFH Active</div>
                  </div>
                  <div
                    class="mr-2 d-flex"
                    v-if="user.is_wfh === true && user.is_active === false"
                  >
                    <div class="circle bg-light"></div>
                    <div class="status-info ml-2">WFH Away</div>
                  </div>
                </div>
              </div>
              <div class="mb-2">
                <i class="fe fe-mail mr-2"></i>
                {{ user.email || "Unknown Email" }}
              </div>
              <div class="mb-2">
                <i class="fe fe-phone mr-2"></i>
                {{ user.contact || "Unknown Contact" }}
              </div>
              <div class="mb-2">
                <i class="fe fe-map-pin text-primary mr-2"></i>
                {{ user.location_name || "Outside Gems Area" }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="card mb-3 health-status-box bg-bpm">
                <div class="card-body">
                  <i class="text-bpm health-image fe fe-heart"></i>
                  <div id="bpm-value2" class="text-bpm health-counter">
                    {{ formatHealth(user.health_data, "heartRate") }}
                  </div>
                  <div class="text-bpm health-title">Bpm</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="card mb-3 health-status-box bg-step">
                <div class="card-body">
                  <i class="text-step health-image fe fe-flag"></i>
                  <div id="step-value2" class="text-step health-counter">
                    {{ formatHealth(user.health_data, "stepCount") }}
                  </div>
                  <div class="text-step health-title">Steps</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="card mb-3 health-status-box bg-spo2">
                <div class="card-body">
                  <i class="text-spo2 health-image fe fe-droplet"></i>
                  <div id="spo2-value2" class="text-spo2 health-counter">
                    {{ formatHealth(user.health_data, "spo2") }}
                  </div>
                  <div class="text-spo2 health-title">%</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="card mb-3 health-status-box bg-sleep">
                <div class="card-body">
                  <i class="text-sleep health-image fe fe-moon"></i>
                  <div id="sleep-value2" class="text-sleep health-counter">
                    {{ formatHealth(user.health_data, "sleep") }}
                  </div>
                  <div class="text-sleep health-title">Hours</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <b-tabs>
            <b-tab active>
              <template #title>
                <i class="fe fe-user"></i>
                <span class="ml-2">Profile</span>
              </template>
              <div class="mt-3">
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <td>NIK</td>
                      <td>{{ user.nik }}</td>
                    </tr>
                    <tr>
                      <td>Company Name</td>
                      <td>{{ user.company_name }}</td>
                    </tr>
                    <tr>
                      <td>Position</td>
                      <td>{{ user.position_name }}</td>
                    </tr>
                    <tr>
                      <td>Latest Time</td>
                      <td>
                        {{ formatDate(user.last_position_time) }}
                      </td>
                    </tr>
                    <tr>
                      <td>Coordinate</td>
                      <td>
                        <div v-if="user.last_position_coordinate">
                          {{ user.last_position_coordinate.x }},
                          {{ user.last_position_coordinate.y }}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Account Type</td>
                      <td>{{ user.account_type }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-tab>
            <b-tab>
              <template #title>
                <i class="fe fe-heart"></i>
                <span class="ml-2">Health Data</span>
              </template>
            </b-tab>
            <b-tab>
              <template #title>
                <i class="fe fe-activity"></i>
                <span class="ml-2">Clinic</span>
              </template>
            </b-tab>
            <b-tab>
              <template #title>
                <i class="fe fe-clock"></i>
                <span class="ml-2">MCU</span>
              </template>
            </b-tab>
            <b-tab>
              <template #title>
                <i class="fe fe-file-text"></i>
                <span class="ml-2">Job Readiness</span>
              </template>
              <div class="mt-3">
                <div class="row" style="max-height: 500px; overflow: auto">
                  <div class="col-10">
                    <div class="timeline">
                      <div
                        class="timeline-container timeline-left"
                        v-for="(item, i) in listJobReadiness"
                        :key="i"
                      >
                        <div class="card">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-6">
                                <div class="mb-2">
                                  <div>Submitted At</div>
                                  <div class="h4 font-weight-bold">
                                    {{ formatDate(item.created_at) }}
                                  </div>
                                </div>
                                <div class="mb-2">
                                  <div>Time Asleep</div>
                                  <div class="h4 font-weight-bold">
                                    {{
                                      `${item.long_hours_of_sleep || 0} Hours`
                                    }}
                                  </div>
                                </div>
                                <div class="mb-2">
                                  <div>Personal Problem</div>
                                  <div class="h4 font-weight-bold">
                                    {{ item.personal_problems ? "Yes" : "No" }}
                                  </div>
                                </div>
                                <div class="mb-2">
                                  <div>Concentration Check</div>
                                  <div class="h4 font-weight-bold">
                                    {{
                                      item.employee_concentration_check
                                        ? "Yes"
                                        : "No"
                                    }}
                                  </div>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="mb-2">
                                  <div>Ready to Work</div>
                                  <div class="h4 font-weight-bold">
                                    {{
                                      item.employee_ready_to_work ? "Yes" : "No"
                                    }}
                                  </div>
                                </div>
                                <div class="mb-2">
                                  <div>Drug Consumption</div>
                                  <div class="h4 font-weight-bold">
                                    {{ item.drug_consumption ? "Yes" : "No" }}
                                  </div>
                                </div>
                                <div class="mb-2">
                                  <div>Response Check</div>
                                  <div class="h4 font-weight-bold">
                                    {{
                                      item.employee_response_check
                                        ? "Yes"
                                        : "No"
                                    }}
                                  </div>
                                </div>
                                <div class="mb-2">
                                  <div>Health Check</div>
                                  <div class="h4 font-weight-bold">
                                    {{
                                      item.employee_health_checkup
                                        ? "Yes"
                                        : "No"
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-modal>
    <!-- End of Modal Employee -->
  </div>
</template>

<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import { icon } from "leaflet";
import moment from "moment";

const easeInOut = (t) => 1 - Math.pow(1 - t, 3);

export default {
  name: "UserLocation",
  data() {
    return {
      tabIndex: 0,
      visiblePeople: false,
      minZoom: 10,
      maxZoom: 20,
      zoom: 10.5,
      center: [115.55964685, -3.70125098],
      rotation: 0,
      selectedFeatures: [],
      selectedArea: {},
      modifiedLoc: [],
      muster_points: [],
      windowHeight: window.innerHeight,
      columns: [
        {
          label: "Company Name",
          field: "company_name",
          width: "200px",
        },
        {
          label: "Fullname",
          field: "fullname",
          width: "200px",
        },
        {
          label: "Email",
          field: "email",
          width: "200px",
        },
        {
          label: "Contact",
          field: "contact",
          width: "100px",
        },
        {
          label: "Position",
          field: "position_name",
          width: "200px",
        },
        {
          label: "Account Type",
          field: "account_type",
          width: "200px",
        },
        {
          label: "Coordinate",
          field: "coordinate",
          width: "200px",
        },
        {
          label: "Action",
          field: "action",
          width: "200px",
        },
      ],
      loading: false,
      filter: {
        location_id: null,
        fullname: "",
        user_id: null,
      },
      user: {
        image: "/img/profile.webp",
      },
      direct: false,
      comp: false,
      // url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      // attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markerLatLng: [-3.494230910434892, 475.6338500976563],
      icon: "/img/miner-active.png",
      iconAway: "/img/miner-away.png",
      iconWFOActive: "/img/miner-wfo-active.svg",
      iconWFOAway: "/img/miner-wfo-away.svg",
      iconWFHActive: "/img/miner-wfh-active.svg",
      iconWFHAway: "/img/miner-wfh-away.svg",
    };
  },
  computed: {
    listGroup() {
      const data = this.$store.getters["location/list_group"];
      return data || [];
    },
    listJobReadiness() {
      const data = this.$store.getters["jobReadiness/userJobreadiness"];
      return data || [];
    },
    listUser() {
      const data = this.$store.getters["user/list"];
      return data || [];
    },
    listPointing() {
      const data = this.$store.getters["location/pointing_users"];
      return data || [];
    },
    locations() {
      return this.$store.getters["location/list"];
    },
    totals() {
      return this.$store.getters["location/status_user"];
    },
  },
  mounted() {
    // this.getAllPointing();
    // this.getListLocation();
    // this.getAllStatus();
    // this.getUsers();
    // this.getGroups();
    this.loadData();
    this.centerFromUrlQuery()
  },
  methods: {
    getIcon(item) {
      if (item.is_wfh === true && item.is_active === true) {
        return this.iconWFHActive;
      } else if (item.is_wfh === true && item.is_active === false) {
        return this.iconWFHAway;
      } else if (item.is_wfh === false && item.is_active === true) {
        return this.iconWFOActive;
      } else if (item.is_wfh === false && item.is_active === false) {
        return this.iconWFOAway;
      } else {
        return this.iconWFHActive;
      }
    },
    detectComponent(e, type) {
      console.log(e, type);
    },
    detectZoom(zoom) {
      this.zoom = zoom;
      if (zoom >= 15) {
        this.visiblePeople = true;
      } else {
        this.visiblePeople = true;
      }
    },
    refreshData() {
      this.loadData();
    },
    findUser() {},
    changeLocation() {
      this.getUsers();
    },
    getGroups() {
      this.$store.dispatch("location/GET_LIST_GROUP", this.filter);
    },
    getUsers() {
      this.$store.dispatch("user/GET_LIST", this.filter);
    },
    getRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    formatCoordinate(item) {
      try {
        const type = item.type;
        if (item.raw_geolocation) {
          let raw = JSON.parse(item.raw_geolocation);
          if (type === "area") {
            return raw[0];
          } else {
            return raw;
          }
        } else {
          return [];
        }
      } catch (err) {
        console.log(err);
        return [];
      }
    },
    clearFilter() {
      this.filter = {
        location_id: null,
        fullname: "",
        user_id: null,
      };
      this.center = [117.56311689, 2.31588456];
      this.zoom = 9;
      this.getAllPointing();
      this.getUsers();
    },
    formatDate(date) {
      return date ? moment(date).format("DD MMM YYYY HH:mm:ss") : date || "-";
    },
    async viewProfile(e, user) {
      this.user = { ...this.user, ...user };
      const image = await this.getImage(user);
      this.user = { ...this.user, ...{ image } };
      console.log("this.user", this.user);
      this.$bvModal.show("view-profile");
    },
    formatHealth(health, type) {
      if (health) {
        try {
          health = JSON.parse(health);
          const health_data = health["health_data"];
          if (type === "heartRate") {
            return health_data["heartRate"] || 0;
          } else if (type === "stepCount") {
            return health_data["stepCount"] || 0;
          } else if (type === "sleep") {
            return health_data["sleep"] || 0;
          } else if (type === "spo2") {
            return health_data["spo2"] || 0;
          } else {
            return 0;
          }
        } catch (err) {
          return 0;
        }
      }
      return 0;
    },
    async getImage(user) {
      let defaultImage = "/img/profile.webp";
      try {
        const nik = user["nik"];
        return `https://profpic.ugems.id/${nik}.jpg`;
      } catch (err) {
        console.log("error", err);
        return defaultImage;
      }
    },
    getAllStatus() {
      this.$store.dispatch("location/GET_STATUS_USER", this.filter);
    },
    getAllPointing() {
      this.loading = true;
      this.$store
        .dispatch("location/GET_POINTING_USERS", this.filter)
        .then(() => {
          const users = this.listUser;
          if (this.filter?.location_id) {
            const selectedLocation = this.filter.location_id;
            const locations = this.locations;
            const indexLocation = locations.findIndex(
              (e) => e.id == selectedLocation
            );
            if (indexLocation > -1) {
              const location = locations[indexLocation];
              let rawCoordinate = location.raw_geolocation;
              try {
                rawCoordinate = JSON.parse(rawCoordinate);
              } catch (error) {
                console.log("Error while parsing rawCoordinate", err);
                return;
              }

              const latitude = rawCoordinate[0][0];
              const longitude = rawCoordinate[0][1];
              this.center = [latitude, longitude];
            }
            setTimeout(() => {
              this.zoom = 13;
            }, 300);
          }

          if (this.filter?.user_id) {
            const userIndex = users.findIndex(
              (e) => e.id === this.filter.user_id
            );
            console.log("qwoiejiwqewq", userIndex);
            if (userIndex > -1) {
              const user = users[userIndex];

              if (user.last_position_coordinate) {
                console.log("xzczxcxz", user.last_position_coordinate);
                this.center = [
                  user.last_position_coordinate.y,
                  user.last_position_coordinate.x,
                ];
                setTimeout(() => {
                  this.zoom = 21;
                }, 300);
              }
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getListLocation() {
      this.$store.dispatch("location/GET_LIST", { pob: true }).then(() => {
        const locs = this.locations;
        const data = [];
        for (let i = 0; i < locs.length; i++) {
          const loc = locs[i];
          let stroke = "#af0404";
          let fill = "rgba(175,4,4,0.5)";
          let raw = JSON.parse(loc.raw_geolocation);
          let raw_geolocation = [];
          if (loc.type === "polygon") {
            for (let j = 0; j < raw.length; j++) {
              const r = raw[j];
              if (Array.isArray(r[0])) {
                let inside = [];
                for (let k = 0; k < r.length; k++) {
                  const el = r[k];
                  inside.push([parseFloat(el[1]), parseFloat(el[0])]);
                }
                raw_geolocation.push(inside);
              } else {
                raw_geolocation.push([parseFloat(r[1]), parseFloat(r[0])]);
              }
            }
          } else {
            raw_geolocation = [parseFloat(raw[0][1]), parseFloat(raw[0][0])];
          }

          data.push({ ...loc, raw_geolocation, stroke, fill });
        }
        console.log('data',JSON.parse(JSON.stringify(data)));
        this.modifiedLoc = JSON.parse(JSON.stringify(data));
      });
    },
    trackUser(user) {
      console.log(user);
      this.tabIndex = 0;
      this.filter.user_id = user.id;
      this.refreshData();
    },
    colorCondition(severity) {
      if (severity === "HIGH") {
        return "#af0404";
      } else if (severity === "MEDIUM") {
        return "#f6c343";
      } else if (severity === "MODERATE") {
        return "#ff7b00";
      } else {
        return "#00d97e";
      }
    },
    async onSelect(evt) {
      this.selectedArea = evt;
      console.log("qwewq", evt);
      const type = evt.json.geometry.type;
      if (type === "Point") {
        this.user = evt.json.properties;
        const image = await this.getImage(this.user);
        this.user = { ...this.user, ...{ image } };
        console.log("this.user", this.user);
        this.$bvModal.show("view-profile");
      }
      console.log("selectedFeatures", this.selectedFeatures);
    },
    onUnselect(evt) {
      console.log("evt", evt);
      this.selectedArea = {};
      this.selectedFeatures = [];
    },
    async viewUser() {
      this.selectedArea = this.selectedFeatures[0];
      console.log("this.selectedFeatures", this.selectedFeatures);
      const type = this.selectedArea.geometry.type;
      if (type === "Point") {
        this.user = this.selectedArea.properties;
        const image = await this.getImage(this.user);
        this.user = { ...this.user, ...{ image } };
        console.log("this.user", this.user);
        this.$bvModal.show("view-profile");
      }
      this.$bvModal.show("view-profile");
    },
    clickPosition(map) {
      console.log("map", map);
      const [lat, long] = map.coordinate;
      console.log(lat, long);
    },
    centerFromUrlQuery() {
      var query = this.$route.query
      if ('lat' in query && 'long' in query) {
        this.center = [parseFloat(query.long), parseFloat(query.lat)]
      }
      if ('z' in query) {
        this.zoom = parseFloat(query.z)
      }
    },
    adjustedRadius(radius) {
      return radius / 100000;
    },
    loadData() {
      this.loading = true;
      Promise.all([
        this.getAllPointing(),
        this.getListLocation(),
        this.getAllStatus(),
        this.getUsers(),
        this.getGroups(),
      ]).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style>
.circle {
  width: 14px;
  height: 14px;
  background-color: red;
  border-radius: 100%;
  border: 0.5px solid black;
}

.status-info {
  line-height: 0.9;
}

.bg-orange {
  background-color: #ff7b00 !important;
}
</style>